import { render, staticRenderFns } from "./WindingInsolvencyDetails.vue?vue&type=template&id=f79af3ae&scoped=true&"
import script from "./WindingInsolvencyDetails.vue?vue&type=script&lang=js&"
export * from "./WindingInsolvencyDetails.vue?vue&type=script&lang=js&"
import style0 from "./WindingInsolvencyDetails.vue?vue&type=style&index=0&id=f79af3ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79af3ae",
  null
  
)

export default component.exports